const UploadErrorMessages = {
    JPG_OR_PNG: "Only JPG/PNG files are supported.",
    IMAGE_SIZE_2MB: "Image must smaller than 2MB.",
    IMAGE_SIZE_4MB: "Image must smaller than 4MB.",
    IMAGE_SIZE_8MB: "Image must smaller than 8MB.",
};

export { UploadErrorMessages };
